import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import ReactAudioPlayer from 'react-audio-player';
import { H3, Button } from '@blueprintjs/core';
import './KwicTable.css';

class Play extends React.PureComponent {

  state = {
     begin:0,
     end:0,
     url:""
  }

  componentDidMount () {
    const url=this.props.wavUrl;
    const m=url.match(/(.+)#t=(.+),(.+)/);
    if (m) {
     this.setState({ url: m[1], begin: parseInt(m[2]), end: parseInt(m[3])})
    }
  }

  backward = () => {
    var newBegin=this.state.begin-10;
    if (newBegin<0) {
      newBegin=0;
    }
    this.setState({begin:newBegin})
  }

  forward = () => {
    var newBegin=this.state.begin+10;
    this.setState({begin:newBegin,end:newBegin+5})
  }

  render() {
      const wavUrl= this.state.url ? this.state.url+"#t="+this.state.begin.toString()+","+this.state.end.toString():this.props.wavUrl;
        return (
          <div className="dialogContainer">
            <H3>{this.props.text}</H3>
            <p>{wavUrl}</p>
            <ReactAudioPlayer  ref={(element) => { this.rap = element; }} src={wavUrl} controls crossOrigin preload autoPlay/> 
            <br/>
            - 10 s. <Button icon='fast-backward' onClick={this.backward}/>  <Button icon='fast-forward' onClick={this.forward}/> + 10 s.
          </div>
            
        );

  }
}

Play.propTypes = {
        // see prepCoocData for an example
        wavUrl: PropTypes.string,
        text: PropTypes.string,
};

export default withTranslation()(Play);
